import * as yup from "yup";
import i18n from "../../i18n";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const phoneFormatMessage = () => i18n.t("validation.phoneFormat", {ns: "common"});

const requiredStringSchema = yup.string().required(requiredMessage);

const orderShape = yup.object().shape({
    receiverName: requiredStringSchema,
    receiverPhone: requiredStringSchema.matches(/^0([0-9]{10})$/, phoneFormatMessage),
    index: yup
        .number()
        .positive()
        .integer()
        .required(requiredMessage),
    receiverAddress: requiredStringSchema,
    receiverAddressDetail: requiredStringSchema,
    orderNumber: requiredStringSchema,
    pickupInfoIndex: yup
        .number()
        .positive()
        .integer()
        .required(requiredMessage),
    receiverLocation: yup.object().shape({
        lon: yup.number().required(requiredMessage),
        lat: yup.number().required(requiredMessage)
    }),
    orderDesiAmount: yup.number().positive(),
    products: yup
        .array()
        .of(
            yup.object().shape({
                productName: requiredStringSchema,
                amount: yup
                    .number()
                    .positive()
                    .integer()
                    .required(requiredMessage),
                productDesiAmount: yup.number().positive(),
                ingredients: requiredStringSchema
            })
        )
        .required(requiredMessage),
    paymentType: yup.string().nullable(true),
    price: yup.string().when("paymentType", {
        is: paymentType => paymentType !== "" && paymentType !== undefined,
        then: yup.string().required(requiredMessage)
    }),
    barcode: yup.string().when("barcodeIsRequired", {
        is: true,
        then: yup.string().required(requiredMessage)
    })
});

const pickupShape = yup.object().shape({
    freePickup: yup.bool().required(requiredMessage),

    name: yup.string().when("freePickup", {is: true, then: requiredStringSchema}),
    pickupPointId: yup.string().when("freePickup", {
        is: false,
        then: yup.string().required(requiredMessage)
    }),
    address: yup.string().when("freePickup", {is: true, then: requiredStringSchema}),

    location: yup.object().when("freePickup", {
        is: true,
        then: yup.object().shape({
            longitude: yup.number().required(requiredMessage),
            latitude: yup.number().required(requiredMessage)
        })
    }),

    index: yup
        .number()
        .positive()
        .integer()
        .required(requiredMessage)
});

yup.addMethod(yup.array, "uniqueProperty", function(propertyName, message) {
    return this.test("unique", message, function(value) {
        if (!value || !value[propertyName]) {
            return true;
        }

        if (
            this.parent.filter(v => v !== value).some(v => v[propertyName] === value[propertyName])
        ) {
            throw this.createError({
                path: `${this.path}.${propertyName}`
            });
        }

        return true;
    });
});

export const newRequestValidation = yup.object().shape({
    //if resend= true pass  the pickupInfos validation
    pickupInfos: yup.array().when("resend", {
        is: false,
        then: yup
            .array()
            .of(pickupShape)
            .required(requiredMessage)
    }),

    courierType: yup.string().required(requiredMessage),
    orders: yup
        .array()
        .of(orderShape)
        .required(requiredMessage)
});

export const apiCredentialsValidation = yup.object().shape({
    companyId: requiredStringSchema,
});
